import { render, staticRenderFns } from "./StoreClassPlan.vue?vue&type=template&id=6db8b871&scoped=true&"
import script from "./StoreClassPlan.vue?vue&type=script&lang=js&"
export * from "./StoreClassPlan.vue?vue&type=script&lang=js&"
import style0 from "./StoreClassPlan.vue?vue&type=style&index=0&id=6db8b871&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db8b871",
  null
  
)

export default component.exports